export const MaleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3332 40.334C10.233 40.334 3.6665 33.7675 3.6665 25.6673C3.6665 17.5671 10.233 11.0006 18.3332 11.0006C26.4333 11.0006 32.9998 17.5671 32.9998 25.6673C32.9998 33.7675 26.4333 40.334 18.3332 40.334Z"
      stroke={props.color ?? "#454643"}
      strokeWidth="2.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.333 3.66702L29.0835 14.916M40.333 3.66702V10.735M40.333 3.66702L33.265 3.66702"
      stroke={props.color ?? "#454643"}
      strokeWidth="2.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
